import { Service } from '@/services/api';
import { NotificationPreference, UserNotification } from '@/types/Notifications';
import { AxiosRequestConfig } from 'axios';

class NotificationService extends Service {
  async getNotifications(ifModifiedSince?: Date): Promise<UserNotification[]> {

    const config: AxiosRequestConfig = {};
    if (ifModifiedSince) {
     config.headers = { 
        'If-Modified-Since': ifModifiedSince.toUTCString(),
      };
    }

    return this.get<UserNotification[]>('/v2/notifications', undefined, config).then(this.handleResponse);
  }

  async markAsRead(id: number): Promise<void> {
    return this.post<void>(`/v2/notifications/${id}/read`, undefined).then(this.handleResponse);
  }

  async deleteNotification(id: number): Promise<void> {
    return this.post<void>(`/v2/notifications/${id}/delete`, undefined).then(this.handleResponse);
  }

  async getPreferences(): Promise<NotificationPreference | undefined> {
    return this.get<NotificationPreference | undefined>('/v2/notifications/preferences').then(this.handleResponse);
  }

  async updatePreferences(pref: NotificationPreference): Promise<void> {
    return this.post<void>('/v2/notifications/preferences', pref).then(this.handleResponse);
  }
}

export default new NotificationService();
